import { render, staticRenderFns } from "./allOrders.vue?vue&type=template&id=21ac94a0"
import script from "./allOrders.vue?vue&type=script&lang=js"
export * from "./allOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports